'use client'

import { ThemeProvider as NextThemesProvider } from 'next-themes'
import { useLocation } from 'react-router-dom'

interface ThemeProviderProps {
  children: React.ReactNode
  defaultTheme?: string
  enableSystem?: boolean
  disableTransitionOnChange?: boolean
}

// Public marketing pages (landing + pricing) always render in light mode,
// regardless of the theme the user has picked inside the app — they share
// no visual identity with the in-app dark theme and shouldn't flip based on
// a preference the visitor may not have set (e.g. right after logging out).
const LIGHT_ONLY_PATHS = ['/', '/pricing']

export function ThemeProvider({
  children,
  ...props
}: ThemeProviderProps) {
  const location = useLocation()
  const forcedTheme = LIGHT_ONLY_PATHS.includes(location.pathname) ? 'light' : undefined

  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem={true}
      disableTransitionOnChange={true}
      forcedTheme={forcedTheme}
      {...props}
    >
      {children}
    </NextThemesProvider>
  )
}